export const createUrl = (baseUrl: string, params?: Record<string, string>): string => {
  const url = new URL(baseUrl);
  for (const [paramKey, paramVal] of Object.entries(params ?? {})) {
    if (paramVal) {
      url.searchParams.append(paramKey, paramVal);
    }
  }
  return url.toString();
};
